import { render, staticRenderFns } from "./ViewPatients.vue?vue&type=template&id=d3156cd2&"
import script from "./ViewPatients.vue?vue&type=script&lang=js&"
export * from "./ViewPatients.vue?vue&type=script&lang=js&"
import style0 from "./ViewPatients.vue?vue&type=style&index=0&id=d3156cd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports